import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'aiChat'] as const;

export const keys = {
  all,
  conversations: (spaceId: string) => [...all, 'conversations', spaceId] as const,
  conversation: (conversationId: string) => [...all, 'conversation', conversationId] as const,
  messages: (conversationId: string) => [...all, 'messages', conversationId] as const,
};
